<template>

  <div class="home">
    <van-form @submit="getTestToken">
    <!-- <van-field v-model="name" label="切换用户" size='large' @click="user_show = true" readonly is-link />
    <van-action-sheet v-model="user_show" :actions="users" @select="user_onselect" /> -->
     <van-field v-model="userid" label="用户ID" size='large' :border="true" placeholder="请输入用户ID" />
    <div style="margin: 20px 0 50px 0;">
          <van-row>
            <!-- <van-col span="12"><van-button type="primary" native-type="submit">保存草稿</van-button></van-col> -->
            <van-col span="24"><van-button  type="info" native-type="submit" >提交</van-button></van-col>
          </van-row>
          
          
        </div>
    </van-form>
  
   <!-- <Footer></Footer> -->
  </div>

  
  

</template>

<script>
// @ is an alias to /src
import Footer from '../components/Footer.vue'
export default {
  name: 'Home',
  components: {
    Footer

  },
  data(){
    return{
      userid:'JT000902688',
      users:{},
      user_show:false,
      name:'',
    }
  },
  created(){
    // this.getCode();
    // console.log(this.$route.query)
    document.title = 'KEEN'
    this.getUsers();

  },
  methods:{
    getUsers(){
      this.$http.post('get_users')
      .then((res)=>{
        this.users = res.data.data

      })
      .catch(function(e) {
        console.log(e); // "Uh-oh!"
      })
    },
    
    getTestToken(){
      this.$http.post('get_test_token',{'userid':this.userid})
      .then((res)=>{
        console.log(res)
        localStorage.token=res.data.data.token;
        this.$cookies.set("token",res.data.data.token,"30D")
        this.$dialog.alert({
          message: '切换成功',
        })
      })
      .catch(function(e) {
        console.log(e); // "Uh-oh!"
      })

    },
    user_onselect(item){
      console.log(item)
      this.user_show = false;
      this.name = item.name;
      this.userid = item.userid;
      console.log(this.userid)

    },
    

  }
}
</script>
<style scoped>

.payment{
  margin:0px 10px 100px 10px;
  padding-top:10px;
}
</style>
